import { z } from "zod";

/**
 * Üzleti dátumok (hatálynap, érvényesség) naptári napként közlekednek: "YYYY-MM-DD".
 * A DB-ben DATE, JS-ben UTC éjfélként kezeljük, így nincs időzóna-csúszás.
 */
export const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Dátum formátum: ÉÉÉÉ-HH-NN")
  .refine((s) => !Number.isNaN(Date.parse(`${s}T00:00:00Z`)), "Érvénytelen dátum");

export function todayIso(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function toIsoDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function parseIsoDate(s: string): Date {
  return new Date(`${s}T00:00:00Z`);
}

export function addDays(iso: string, days: number): string {
  const d = parseIsoDate(iso);
  d.setUTCDate(d.getUTCDate() + days);
  return toIsoDate(d);
}
